/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo, type KeyboardEvent, type MouseEvent } from 'react';
import { usePageLayoutResize } from '@jira/design-system__navigation-system/src/PageLayout.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook } from '@atlassian/react-sweet-state';
import type { LeftSidebarState } from '../../../../common/types.tsx';
import { layoutStore } from '../../store/index.tsx';

const useSweetStateLeftSidebarState = createHook(layoutStore, {
	selector: (state) => ({
		...state.content.leftSidebar,
		shouldRender: !state.isChromeless,
	}),
});

type ExtenedLeftSidebarState = LeftSidebarState & {
	shouldRender: boolean;
};

export const useLeftSidebarState = (): ExtenedLeftSidebarState => {
	const [leftSidebar] = useSweetStateLeftSidebarState();
	return leftSidebar;
};

export const useLeftSidebarController = (): {
	collapseLeftSidebar: (
		event?: MouseEvent | KeyboardEvent,
		collapseWithoutTransition?: boolean,
	) => void;
	expandLeftSidebar: () => void;
} => {
	const { expandLeftSidebar, collapseLeftSidebar } = usePageLayoutResize();
	return useMemo(
		() => ({
			collapseLeftSidebar,
			expandLeftSidebar,
		}),
		[collapseLeftSidebar, expandLeftSidebar],
	);
};
